import { Allocation, AllocationType } from '@ndvr/portfolio-api';

/**
 * An Allocation being cloned into a new one — everything but the identity. Modeling this
 * explicitly (rather than casting a fabricated `{ ...allocation, allocationGUID: undefined }`
 * through `as unknown as Allocation`) keeps the "is this new?" check type-driven instead of
 * relying on an object that lies about its own shape.
 */
export type AllocationDraft = Omit<Allocation, 'allocationGUID'> & { allocationGUID?: undefined };

/**
 * Returns the allocation type to use when cloning an allocation.
 *
 * If the user can't create shared allocations, force the clone to PERSONAL so the
 * dialog doesn't silently submit a SHARED request the backend will reject.
 */
export const resolveClonedAllocationType = (
    source: AllocationType,
    canCreateSharedAllocation: boolean,
): AllocationType =>
    !canCreateSharedAllocation && source === AllocationType.SHARED ? AllocationType.PERSONAL : source;
